import { create } from "zustand";
import Mensaje from "sweetalert";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../Home/useStoreHome";
import moment from "moment";

export const useStoreReportes = create((set, get) => {
  return {
    TipoProducto: "Todos",
    ListaStock: [],
    BuscandoStock: false,
    getStock: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoStock) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, Lote: get().LoteProduccion || "", TipoProducto: get().TipoProducto };
      set({ BuscandoStock: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("PISeunReportes/Stock", sParametros);
        if (data.error) {
          Mensaje("Error al traer stock", data.error, "error");
        } else {
          
          set({ ListaStock: data.data.Lista });
        }
      }
      catch (error) {
        Mensaje("Error al traer stock", error.message, "error");
      }
      set({ BuscandoStock: false });
    },
ListaStockExcel: [],
    BuscandoStockExcel: false,
    getStockExcel: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoStockExcel) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, Lote: get().LoteProduccion || "", TipoProducto: get().TipoProducto };
      set({ BuscandoStockExcel: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("PISeunReportes/StockExcel", sParametros);
        if (data.error) {
          Mensaje("Error al traer stock", data.error, "error");
        } else {
          set({ ListaStockExcel: data.data.Lista });
        }
      }
      catch (error) {
        Mensaje("Error al traer stock", error.message, "error");
      }
      set({ BuscandoStockExcel: false });
    },

    

    FechaDesde: moment().subtract(7, "days").toDate(),
    FechaHasta: new Date(),
    ListaIngresado: [],
    ListaIngresadoPorProveedor: [],
    BuscandoIngresos: false,
    getIngresados: async () => {
      if (!useStoreHome.getState().EmpresaId) { return; }
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        FechaDesde: moment(get().FechaDesde).format("YYYY-MM-DD"),
        FechaHasta: moment(get().FechaHasta).format("YYYY-MM-DD"),
        Lote: get().Lote || "",
        TipoProducto: get().TipoProducto
      };
      try {
        const data = await _Componentes_WebApiCalls_Post("PISeunReportes/ListaIngresado", sParametros);
        set({ BuscandoIngresos: true });

        if (data.error) {
          Mensaje("Error al traer ingresos", data.error, "error");
        } else {
          set({ ListaIngresado: data.data.ListaIngresado });
          set({ ListaIngresadoPorProveedor: data.data.ListaIngresadoPorProveedor });
        }
      } catch (error) {
        Mensaje("Error al traer ingresos", error.message, "error");
      } finally {
        set({ BuscandoIngresos: false });
      }
    },


    ListaEntradas: [],
    ListaSalidas: [],
    BuscandoEntradasSalidas: false,
    getEntradasSalidas: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoEntradasSalidas) { return; }
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        FechaDesde: moment(get().FechaDesde).format("YYYY-MM-DD"),
        FechaHasta: moment(get().FechaHasta).format("YYYY-MM-DD"),
        Lote: get().LoteProduccion || "",
        TipoProducto: get().TipoProducto
      };
      set({ BuscandoEntradasSalidas: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("PISeunReportes/ListaEntradasSalidas", sParametros);

        if (data.error) {
          Mensaje("Error al traer entradas y salidas", data.error, "error");
        } else {
          const ListaEntradas = (data.data.ListaEntradas || []).map((item) => ({
            ...item,
            MercaderiaDescripcion: item.MercaderiaDescripcion ?? item.Descripcion ?? item.sDescripcion ?? "",
            Peso: Number(item.Peso ?? item.nPeso ?? 0),
            nPeso: Number(item.nPeso ?? item.Peso ?? 0),
            Unidades: Number(item.Unidades ?? item.nUnidades ?? 0),
            nUnidades: Number(item.nUnidades ?? item.Unidades ?? 0),
          }));
          const ListaSalidas = (data.data.ListaSalidas || []).map((item) => ({
            ...item,
            MercaderiaDescripcion: item.MercaderiaDescripcion ?? item.Descripcion ?? item.sDescripcion ?? "",
            nPesoOriginal: Number(item.nPesoOriginal ?? item.Peso ?? item.nPeso ?? 0),
            nUnidades: Number(item.nUnidades ?? item.Unidades ?? 0),
          }));
          set({ ListaEntradas, ListaSalidas });
        }
      } catch (error) {
        Mensaje("Error al traer entradas y salidas", error.message, "error");
      } finally {
        set({ BuscandoEntradasSalidas: false });
      }
    },

    ListaPorMercaderia: [],
    ListaPorCliente: [],
    BuscandoDespachado: false,
    getDespachado: async () => {
      if (!useStoreHome.getState().EmpresaId) { return; }
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        FechaDesde: moment(get().FechaDesde).format("YYYY-MM-DD"),
        FechaHasta: moment(get().FechaHasta).format("YYYY-MM-DD")
      };
      try {
        const data = await _Componentes_WebApiCalls_Post("PISeunReportes/ListaDespachado", sParametros);
        set({ BuscandoDespachado: true });

        if (data.error) {
          Mensaje("Error al traer despachado", data.error, "error");
        } else {
          set({ ListaPorMercaderia: data.data.ListaPorMercaderia });
          set({ ListaPorCliente: data.data.ListaPorCliente });
        }
      } catch (error) {
        Mensaje("Error al traer despachado", error.message, "error");
      } finally {
        set({ BuscandoDespachado: false });
      }
    },


  };
});
